import { SectionHeading } from "./shared";

export default function SeasonsSection({ t }) {
  return (
    <section className="bg-white py-16 sm:py-24 lg:py-32" data-testid="weddings-seasons">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10">
        <SectionHeading eyebrow={t.seasonEyebrow} title={t.seasonTitle} titleAccent={t.seasonTitleAccent} subtitle={t.seasonSubtitle} />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
          {t.seasons.map((s, i) => (
            <div key={i} className="bg-white p-4 sm:p-7 border border-[#EFE4D2] rounded-sm hover:border-[#C9A87C] transition" data-testid={`weddings-season-${i}`}>
              <p className="text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.3em] text-[#B8966F] mb-1.5 sm:mb-2">{s.period}</p>
              <h3 className="text-lg sm:text-xl mb-2 sm:mb-3 text-[#1F1815]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>{s.label}</h3>
              <p className="text-xs sm:text-sm text-[#6B5D4F] font-light leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
